
<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Nilai WOM">
            <common-training-header/>
        </a-page-header>

        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px"></a-col>
            <a-col flex="0 1 300px"><a-button type="primary" icon="plus" block @click="showModal('')"> Tambah Nilai WOM</a-button></a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.woms"
                rowKey="id"
                :pagination="false"
                @change="tableChanged"
                :loading="loading"
                bordered>

                <a-table-column key="min_score" title="Nilai Minimal" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ record.min_score }}
                    </template>
                </a-table-column>

                <a-table-column key="max_score" title="Nilai Maksimal" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ record.max_score }}
                    </template>
                </a-table-column>

                <a-table-column key="title" title="Keterangan" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ record.title }}
                    </template>
                </a-table-column>

                <a-table-column key="hex" title="Hexa" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-tag :color="record.hex">
                            {{ record.hex }}
                        </a-tag>
                    </template>
                </a-table-column>

                <a-table-column key="action" title="Action" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-tooltip title="Edit Nilai WOM">
                            <a-button
                                size="small"
                                type="primary"
                                icon="edit"
                                @click="showModal(record.id)"
                            />
                        </a-tooltip>
                    </template>
                </a-table-column>
            </a-table>

            <a-modal
                :destroyOnClose="true"
                :footer="null"
                :visible="visible"
                :closable="false"
            >
                <classical-wom-form
                    :wom="this.wom"
                    @handleClose="closeModal"
                />
            </a-modal>

        </a-card>
    </div>
</template>

<script>

export default {
    props: {
        training: {
            type: Object
        }
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            expand: false,
            visible: false,
            wom: null,
            processing: false,
            items: {},
            filters: {
                q: null,
                page: 1
            }
        };
    },
    created() {
        this.items = this.getDefaultPagination();
        this.filters = _.merge(this.filters, this.$laravel.request);
        this.getItems();
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault();
            this.pushState(this.filters);
            this.getItems();
        },
        handleReset(e) {
            e.preventDefault();
            this.filters = {
                q: null,
                page: 1
            };
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current;
            this.pushState(this.filters);
            this.getItems();
        },
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.wom"), {
                    params: this.filters
                })
                .then(response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        showModal(hash) {
            this.wom = hash.toString();
            this.visible = true;
        },
        closeModal(isRefresh) {
            this.visible = false;

            if (isRefresh == true) {
                this.getItems();
            }
        }
    },
    filters: {
        upper(value){
            if(!value) return ''
                value = value.toString()
            return value.toUpperCase()
        },
        lower(value){
            if(!value) return ''
                value = value.toString()
            return value.toLowerCase()
        }
    }
};
</script>
